import * as React from 'react';

import { Avatar, Button, Card, Modal, Typography } from 'antd';

import { constants } from 'helpers';
import type { IUserData } from 'v2/interfaces/user';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  user: IUserData;
}

function Consultancy({ user }: IProps) {
  const [openModal, setOpenModal] = React.useState(false);

  if (!user || !user?.wallet) return null;

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Card className='mb-2'>
        <div className='flex flex-col justify-center gap-4'>
          <div className='flex items-center gap-4'>
            <Avatar src='/img/icon-lightbulb.svg' alt='Icone Lâmpada' size={40} />
            <div className='flex flex-col'>
              <Typography.Text strong>Precisa de visão estratégica?</Typography.Text>
              <Typography.Text type='secondary'>
                Nossos analistas te guiam com insights e soluções da plataforma.
              </Typography.Text>
            </div>
          </div>
          <Button onClick={handleOpenModal} id='schedule-btn' icon={<Icon.Calendar />}>
            Agendar consultoria
          </Button>
          <Modal
            open={openModal}
            onCancel={handleCloseModal}
            title='Agendar consultoria'
            width={900}
            footer={
              <div className='flex justify-end'>
                <Button type='text' onClick={handleCloseModal}>
                  Fechar
                </Button>
              </div>
            }
          >
            <div className='h-[70vh]'>
              <iframe
                src={constants.HUBSPOT_WIDGET_URL}
                title='Consultoria'
                id='hubspot-widget'
                className='size-full rounded-(--uizz-antd-border-radius) border-0'
              />
            </div>
          </Modal>
        </div>
      </Card>
    </>
  );
}

export { Consultancy };
